export const aciMedicine = {
    iconName: 'medicine',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 21 21' },
        path: [
            {
                attr: {
                    d: 'M19.377 1.623A5.5 5.5 0 0015.461 0c-1.48 0-2.871.576-3.917 1.623l-4.96 4.96-4.962 4.961A5.504 5.504 0 000 15.461c0 1.48.576 2.87 1.622 3.916A5.5 5.5 0 005.54 21c1.48 0 2.87-.576 3.916-1.623l4.961-4.96 4.961-4.961a5.504 5.504 0 001.622-3.917c0-1.48-.576-2.87-1.622-3.916zM8.411 18.333a4.036 4.036 0 01-2.872 1.19 4.034 4.034 0 01-2.872-1.19 4.035 4.035 0 01-1.19-2.872c0-1.084.423-2.105 1.19-2.872l4.438-4.44 5.745 5.746-4.439 4.438zm9.922-9.922l-4.439 4.44L8.15 7.104l4.438-4.438a4.036 4.036 0 012.873-1.19c1.085 0 2.104.423 2.871 1.19a4.035 4.035 0 011.19 2.872 4.038 4.038 0 01-1.19 2.872z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M17.435 4.98a.739.739 0 01-.61-.32 1.848 1.848 0 00-2.831-.266.738.738 0 11-1.044-1.044 3.325 3.325 0 015.094.474.739.739 0 01-.609 1.156z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
